import React, { FC } from 'react';
import { FormikHelpers } from 'formik';
import Signature from '../../../../library/inputs/signature/Signature';

interface Props {
  id: string;
  setFieldTouched: FormikHelpers<string>['setFieldTouched'];
  setFieldValue: FormikHelpers<string>['setFieldValue'];
  readOnlyMode?: boolean;
  img?: string;
}

const SignatureField: FC<Props> = ({ id, setFieldTouched, setFieldValue, readOnlyMode, img }: Props) => {
  return (
    <Signature
      onChange={async (val: string) => {
        await setFieldValue(id, val, true);
      }}
      onTouched={async () => {
        await setFieldTouched(id, true, true);
      }}
      readOnlyMode={readOnlyMode}
      img={img}
    />
  );
};

export default SignatureField;
